/**
 * Orders outlets (restaurants/stores) by their API `position`, lowest first.
 * Items without a position go last and keep the order the API sent.
 * Returns a new array; the input isn't changed.
 */
export function sortByPosition(list) {
  if (!Array.isArray(list)) return list;
  const rank = (item) => {
    const position = Number(item?.position);
    return item?.position == null || Number.isNaN(position)
      ? Infinity
      : position;
  };
  return [...list].sort((a, b) => rank(a) - rank(b));
}
